import { useEffect } from 'react';
import type { VehicleDetailsPayload } from '~/contracts/dealership/ShiftDigital';
import useShiftDigitalPageViewEventTracker from './useShiftDigitalPageViewEventTracker';

export default function useTrackShiftDigitalPageViewEvent(
  shouldSend: boolean,
  vehicleDetails?: VehicleDetailsPayload
) {
  const trackShiftDigitalPageViewEvent =
    useShiftDigitalPageViewEventTracker(vehicleDetails);

  useEffect(() => {
    if (!shouldSend) return;

    trackShiftDigitalPageViewEvent();
  }, [shouldSend, trackShiftDigitalPageViewEvent]);
}
